export default "__VITE_ASSET__BA$AklV$__"